const oldRoutes = {
  homePage: "/",
  loginPage: "/login/",

  // Miscellaneous
  docsPage: "/docs/:docId/",
  docsPage__overview: "/docs/introduction/",
  accessDenied: "/access-denied/",
  help: "/help/",
  settings: "/settings/",
};

const newRoutes = {
  ...oldRoutes, // remove this once all the old routes are removed.

  // dashboard
  dashboard: "/",
  // Offline Payments
  offlinePayments: "/offline-payments",
  offlinePayments__overview: "/offline-payments/overview",
  offlinePayments__paymentLink: "/offline-payments/payment-link",
  offlinePayments__recordAndView: "/offline-payments/record-and-view",
  offlinePayments__salesLink: "/offline-payments/sales-link",
  offlinePayments__createSalesLink: "/offline-payments/sales-link/create",
  offlinePayments__viewSalesLink: "/offline-payments/sales-link/view/:id",
  offlinePayments__singaporeOfflineUpload:
    "/offline-payments/singapore-offline-upload",
  offlinePayments__createSingaporeOfflineUpload:
    "/offline-payments/singapore-offline-upload/create",
  offlinePayments__viewSingaporeOfflineUpload:
    "/offline-payments/singapore-offline-upload/view/:id",
  offlinePayments__generalOfflineUpload:
    "/offline-payments/general-offline-upload",
  offlinePayments__createGeneralOfflineUpload:
    "/offline-payments/general-offline-upload/create",
  offlinePayments__viewGeneralOfflineUpload:
    "/offline-payments/general-offline-upload/view/:id",
  // Transfers - Reshortlisting and payment transfers
  transfers: "/transfers",
  transfers__overview: "/transfers/overview",
  transfers__batchAndPayment: "/transfers/batch-and-payment",
  transfers__currencyAndProgram: "/transfers/currency-and-program",
  transfers__paymentTransfer: "/transfers/payment-transfer",
  transfers__bulkBatchTransfer: "/transfers/bulk-batch-transfer",
  transfers__bulkBatchTransferBySlug: "/transfers/bulk-batch-transfer-by-slug",
  // Applications - Resend Offer Letter
  applications: "/applications",
  applications__overview: "/applications/overview",
  applications__offerLetter: "/applications/offer-letter",
  // Refunds - Refund Upload and history
  refunds: "/refunds",
  refunds__overview: "/refunds/overview",
  refunds__recordAndView: "/refunds/record-and-view",
  refunds__dashboard: "/refunds/dashboard",
  refunds__create: "/refunds/create",
  refunds__edit: "/refunds/:id",

  // Quotation - Corporate price quotations (WSM migration)
  quotation: "/quotation",
  quotation__dashboard: "/quotation/dashboard",
  quotation__create: "/quotation/create",
  quotation__edit: "/quotation/edit/:id",
  quotation__view: "/quotation/view/:id",

  // Purchase Orders - B2B corporate purchase orders (WSM migration)
  purchaseOrder: "/purchase-order",
  purchaseOrder__dashboard: "/purchase-order/dashboard",
  purchaseOrder__create: "/purchase-order/create",
  purchaseOrder__edit: "/purchase-order/edit/:id",
  purchaseOrder__view: "/purchase-order/view/:id",
  purchaseOrder__customerCreate: "/purchase-order/customers/create",
  purchaseOrder__customerEdit: "/purchase-order/customers/edit/:id",
  purchaseOrder__customerView: "/purchase-order/customers/view/:id",
  purchaseOrder__orderCreate: "/purchase-order/orders/create",
  purchaseOrder__orderEdit: "/purchase-order/orders/edit/:id",
  purchaseOrder__orderView: "/purchase-order/orders/view/:id",
  purchaseOrder__deliveryNote: "/purchase-order/orders/:id/delivery-note",

  // Coupons - Coupon management
  coupons: "/coupons",
  coupons_overview: "/coupons/overview",
  coupons_dashboard: "/coupons/dashboard",
  coupons_applyCoupon: "/coupons/apply-coupon",
  coupons_paymentMode: "/coupons/payment-mode",
  coupons_revokeCoupon: "/coupons/revoke-coupon",
  // Transfers - Reshortlisting and payment transfers
  deferrals: "/deferrals",
  deferrals__overview: "/deferrals/overview",
  deferrals__raiseRequest: "/deferrals/raise-request",
  deferrals__reviewRequest: "/deferrals/review-request",
  deferrals__bulkRecordAndView: "/deferrals/bulk-record-and-view",
  deferrals__bulkRecordAndViewBySlug: "/deferrals/bulk-record-and-view-by-slug",
  deferrals__bulkFeeRecordAndView: "/deferrals/bulk-fee-record-and-view",
  // User Info
  userInfo: "/user-info",
  userInfo__overview: "/user-info/overview",
  userInfo__transactions: "/user-info/transactions",
  userInfo__orderDetails: "/user-info/order/:billingRequestId",

  userInfo__nsdcLoginList: "/user-info/nsdc-login-list",
  userInfo__learnersLoginList: "/user-info/login-list",
  userInfo__userMigration: "/user-info/user-migration",
  userInfo__gguUsersUpload: "/user-info/ggu-users-upload",
  userInfo__iitdUsersUpload: "/user-info/iitd-users-upload",
  userInfo__groupOrder: "/user-info/group-order",
  userInfo__createGroupOrder: "/user-info/group-order/create",
  userInfo__viewGroupOrder: "/user-info/group-order/view/:id",
  // Franchise
  franchise: "/franchise",
  franchise__overview: "/franchise/overview",
  franchise__franchiseView: "/franchise/franchise-view",
  franchise__users: "/franchise/:franchiseCode/users",
  //  Document
  document: "/document",
  document__overview: "/document/overview",
  document__documentList: "/document/document-list",
  // Subscriptions
  subscriptions: "/subscriptions",
  subscriptions__overview: "/subscriptions/overview",
  subscriptions__create: "/subscriptions/create",
  subscriptions__dashboard: "/subscriptions/dashboard",
  subscriptions__edit: "/subscriptions/edit/:id",
  subscriptions__cancel: "/subscriptions/cancel/:id",
  // Stores
  stores: "/stores",
  stores__overview: "/stores/overview",
  stores__storeList: "/stores/store-list",
};

module.exports = { ...newRoutes };
